import { AuthContextProps } from "../components/auth-context";
import { getData, postData } from "./core";
export default class PurchaseApi {
  static uri = "a/internet/purchase";
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }

  get(id: string) {
    return getData({
      uri: PurchaseApi.uri,
      id,
      context: this.context,
    });
  }

  post(id: string) {
    return postData({
      uri: PurchaseApi.uri,
      id,
      context: this.context,
    });
  }
}
